module.exports = {
    minshew: {
        primaryMenuItems: [
            {
                displayText: 'Import Profiles',
                link: '/admin/importprofile/StartNewImportPage.seam',
                external: false,
                subMenu: null,
            },
            {
                displayText: 'Manage Users',
                link: '/admin/educator/SearchEducator.seam',
                external: false,
                subMenu: null,
            },
            {
                displayText: 'Manage Students',
                link: '/admin/student/SearchStudent.seam',
                external: false,
                subMenu: null,
            },
            {
                displayText: 'Manage Test Sessions',
                link: '/admin/supervisor/ManageTestSessions.seam',
                external: false,
                subMenu: null,
            },
            {
                displayText: 'Manage Data Partners',
                link: '/partner-auth/manage-agreements',
                external: false,
                subMenu: null,
            },
            {
                displayText: 'MAP Skills',
                link: '/skills-navigator/educator',
                external: false,
                subMenu: null,
            },
            {
                displayText: 'View Reports',
                subMenu: [
                    {
                        displayText: 'Map Growth Reports',
                        link: '/report/home/map',
                        external: false,
                        subMenu: null,
                    },
                    {
                        displayText: 'Operational Reports',
                        link: '/report/home/operational',
                        external: false,
                        subMenu: null,
                    },
                    {
                        displayText: 'Reports Queue',
                        link: '/report/reportsQueue.seam',
                        external: false,
                        subMenu: null,
                    },
                ],
                external: false,
            },
            {
                displayText: 'Modify Preferences',
                subMenu: [
                    {
                        displayText: 'Modify District',
                        link: '/admin/clientpreferences/ModifyDistrict.seam',
                        external: false,
                        subMenu: null,
                    },
                    {
                        displayText: 'Manage Terms',
                        link: '/admin/clientpreferences/ManageReportingYears.seam',
                        external: false,
                        subMenu: null,
                    },
                    {
                        displayText: 'Modify Tests',
                        link: '/admin/clientpreferences/ModifyTests.seam',
                        external: false,
                        subMenu: null,
                    },
                    {
                        displayText: 'Modify Help Contact',
                        link: '/admin/clientpreferences/ModifyHelpContact.seam',
                        external: false,
                        subMenu: null,
                    },
                ],
                external: false,
            },
        ],
        secondaryMenuItems: [
            {
                displayText: 'Home',
                link: '/admin/home.seam',
                external: false,
                subMenu: null,
            },
            {
                displayText: 'Help',
                link: '/assist',
                external: false,
                subMenu: null,
            },
            {
                displayText: 'Contact',
                link: '/admin/common/contact.seam',
                external: false,
                subMenu: null,
            },
            {
                displayText: 'Change Password',
                link: '/admin/account/ChangePassword.seam',
                external: false,
                subMenu: null,
            },
            {
                displayText: 'Logout',
                link: '/auth/rest/logout',
                external: false,
                subMenu: null,
            },
        ],
    },
    bob: {
        primaryMenuItems: [
            {
                displayText: 'Import Profiles',
                link: '/admin/importprofile/StartNewImportPage.seam',
                external: false,
                subMenu: null,
            },
            {
                displayText: 'View Reports',
                subMenu: [
                    {
                        displayText: 'Map Growth Reports',
                        link: '/report/home/map',
                        external: false,
                        subMenu: null,
                    },
                    {
                        displayText: 'Reports Queue',
                        link: '/report/reportsQueue.seam',
                        external: false,
                        subMenu: null,
                    },
                ],
                external: false,
            },
        ],
        secondaryMenuItems: [
            {
                displayText: 'Home',
                link: '/admin/home.seam',
                external: false,
                subMenu: null,
            },
        ],
    },
};
